import {useState, useCallback} from "react";
import {useDispatch} from "react-redux";
import {useDisclosure} from "../../../hooks/useDisclosure";
import {sendDeleteContactRequest} from "../../../redux/Actions/contacts.actions";

export const useContactTableActions = (fetchAfterDelete = () => {}) => {
  const {
    isOpen: isEditModalOpen,
    onOpen: openEditModal,
    onClose: closeEditModal,
  } = useDisclosure();
  const {
    isOpen: isDeleteModalOpen,
    onOpen: openDeleteModal,
    onClose: closeDeleteModal,
  } = useDisclosure();
  const dispatch = useDispatch();
  const [selectedRow, setSelectedRow] = useState(null);

  const clearSelectedRow = () => {
    setSelectedRow(null);
  };

  const handleActionSelection = useCallback((action, data) => {
    setSelectedRow(data);
    switch (action) {
      case "Edit":
        openEditModal();
        break;
      case "Delete":
        openDeleteModal();
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const deleteContactHandler = () => {
    const callback = () => {
      closeDeleteModal();
      clearSelectedRow();
      fetchAfterDelete();
    };
    dispatch(sendDeleteContactRequest(selectedRow.id, callback));
  };

  const handleDeleteModalClose = () => {
    closeDeleteModal();
    clearSelectedRow();
  };

  const handleEditModalClose = () => {
    closeEditModal();
    clearSelectedRow();
  };

  return {
    closeDeleteModal: handleDeleteModalClose,
    closeEditModal: handleEditModalClose,
    deleteContactHandler,
    isDeleteModalOpen,
    isEditModalOpen,
    handleActionSelection,
    selectedRow,
  };
};
